import { AddSellerDialogUi } from '@/components/Seller/AddSellerDialog/AddSellerDialogUi';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import {
  createSeller,
  getSellerDeliveryDays,
  updateSellerDeliverySchedules,
} from '@/data/api/request/sellerRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addSellerDialogUiToCreateSellerRequest } from './mapper';

export function useCreateSeller() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (addSellerDialogUi: AddSellerDialogUi) => {
      const days = await getSellerDeliveryDays();
      const deliverySchedulers = days.map((day) => ({
        delivery_day_id: day.delivery_day_id,
        is_active: false,
      }));
      const createSellerResponse = await createSeller(
        addSellerDialogUiToCreateSellerRequest(addSellerDialogUi)
      );
      await updateSellerDeliverySchedules({
        sellerId: createSellerResponse.business_id,
        updateSellerDeliverySchedulesRequest: deliverySchedulers,
      });
    },
    onSuccess: () => {
      showSnackSuccess('Vendedor creado');
      queryClient.invalidateQueries({ queryKey: [cacheKeys.seller.list] });
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  return mutation;
}
